import React from "react";
import Page from "components/Page";

import {
  Card,
  CardBody,
  Row,
  Col
} from "reactstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

const PreguntasFrecuentes = ({ datosPreguntasFrecuentes }) => {

  return (
    <Page >
      <Card className="flex-row">
        <CardBody>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <h2 style={{ color: "#001871", textAlign: "center" }}> PREGUNTAS FRECUENTES</h2>
              <Accordion>
                {datosPreguntasFrecuentes.PreguntasFrecuentes && datosPreguntasFrecuentes.PreguntasFrecuentes.map((pregunta, i) =>

                  <AccordionItem key={'pregFreu' + i}>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {pregunta.preNombre}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>

                    <div style={{ textAlign: 'justify', }} dangerouslySetInnerHTML={{ __html: pregunta.preDescripcion }} />
                 
                    </AccordionItemPanel>
                  </AccordionItem>
                )}
              </Accordion>
            </Col>
          </Row>
        </CardBody>
      </Card>

    </Page>
  );
}

export default PreguntasFrecuentes;
